import React, { Fragment, useEffect, useRef, useState } from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import {
  Button,
  Col,
  Container,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap";
import axios from "axios";
import { GetCookieToken } from "../Cookie/GetCookie";
import { FetchAxiosGet } from "../../api/axios";
import Lottie from "react-lottie";
import * as loadingLeaveSumary from "../../assets/lottieAnimation/loadingLeaveSumary.json";
import {
  adjustApproveLevel,
  CheckApprovedEvaluate,
  checkMaxDate,
  EVALUATE_WEIGHT_NORMAL,
  getEvaluateWeight,
  pickUserLevelEvaluateFlow,
} from "./evaluateConfig";
import { DEVELOPMENT_TOPICS } from "./shared/developmentTopics";
import { createBehaviorRows, shouldUseOldBehaviorRows } from "./shared/behaviorTemplate";

const API_URL = process.env.REACT_APP_API_CORS;
const NEW_BUDGET_YEAR_MIGRATE = 2568;

export const convertToThaiDate = utcDateString => {
  const date = new Date(utcDateString);

  const thaiMonths = [
    "มกราคม",
    "กุมภาพันธ์",
    "มีนาคม",
    "เมษายน",
    "พฤษภาคม",
    "มิถุนายน",
    "กรกฎาคม",
    "สิงหาคม",
    "กันยายน",
    "ตุลาคม",
    "พฤศจิกายน",
    "ธันวาคม",
  ];

  const thaiMonth = thaiMonths[date.getUTCMonth()];
  const thaiYear = date.getUTCFullYear() + 543;
  const day = date.getUTCDate();
  return `${isNaN(day) ? "" : day} ${thaiMonth || ""} ${isNaN(thaiYear) ? "" : thaiYear}`;
};

const DEVELOPMENT_TYPE_TH = DEVELOPMENT_TOPICS

const SCORE_LEVELS = [
  { label: "ดีเด่น", range: "(90-100)", test: r => r >= 90 && r <= 100 },
  { label: "ดีมาก", range: "(80-89)", test: r => r >= 80 && r < 90 },
  { label: "ดี", range: "(70-79)", test: r => r >= 70 && r < 80 },
  { label: "พอใช้", range: "(60-69)", test: r => r >= 60 && r < 70 },
  { label: "ต้องปรับปรุง", range: "(<60)", test: r => r < 60 },
];

const CheckMark = ({
  checked,
  checkedClassName = "fa-solid fa-check p-1 fa-lg",
  emptyPadding = "11px",
  emptyMarginRight,
}) => (
  <span className="border border-1 border-black me-2">
    {checked ? (
      <i className={checkedClassName}></i>
    ) : (
      <i style={{ padding: emptyPadding, marginRight: emptyMarginRight }}></i>
    )}
  </span>
);

const DottedField = ({ children, width = "250px", extraStyle, className = "" }) => (
  <span
    className={`text-center ${className}`}
    style={{
      borderBottomStyle: "dotted",
      borderWidth: "2px",
      width,
      height: "25px",
      display: "inline-block",
      ...extraStyle,
    }}
  >
    <b>{children}</b>
  </span>
);

const SupervisorApprovalBlock = ({
  title,
  approveUserLv,
  approveNameLv,
  approveFullNameLv,
  evaluateSalaryApprove,
  dateSourceUserId,
}) => {
  const approvedRecord = CheckApprovedEvaluate(evaluateSalaryApprove, approveUserLv?.approve_user_id);
  const dateRecord = CheckApprovedEvaluate(evaluateSalaryApprove, dateSourceUserId);

  return (
    <Row className="border border-1 border-black">
      <Row className="mt-1">
        <b>{title}</b>
      </Row>
      <Row className="mt-1 ms-2">
        <Col>
          <CheckMark checked={false} />
          <span>เห็นด้วยกับผลการประเมิน</span>
        </Col>
      </Row>
      <Row className="mt-1 ms-2">
        <Col>
          <CheckMark checked={false} />
          <span>มีความเห็นต่าง ดังนี้</span>
        </Col>
      </Row>
      <Row className="mt-1 ms-2">
        <Col xs={6} md={6} lg={6}>
          {Array.from({ length: 3 }).map((_, i) => (
            <Col key={i}>
              <span style={{ paddingLeft: "32px" }}>
                <DottedField width="170px">{""}</DottedField>
              </span>
            </Col>
          ))}
        </Col>
        <Col xs={6} md={6} lg={6}>
          <Row className="text-end pe-4 pb-5">
            <span>
              <span>ลงชื่อ : </span>
              <DottedField width="250px">{approveNameLv || ""}</DottedField>
            </span>
            {approveFullNameLv !== undefined && (
              <span>
                <DottedField width="250px">{approveFullNameLv ? `(${approveFullNameLv})` : ""}</DottedField>
              </span>
            )}
            <span className="mt-5">
              <span>ตำแหน่ง : </span>
              <DottedField width="235px">{approveUserLv?.approve_user_position_name}</DottedField>
            </span>
            <span className="mt-2">
              <span>วันที่ : </span>
              <DottedField width="256px">{convertToThaiDate(dateRecord?.approve_date)}</DottedField>
            </span>
          </Row>
        </Col>
      </Row>
    </Row>
  );
};

const buildEvaluateParams = ({ orderField, orderDir, size, status, budgetYear, round, evaluateSalaryID, userID, checkPointApproved, approveCheckPointUser, lastStepApproved, assessor1 }) => {
  const filters = {
    page: 1,
    size,
    "order[0]": orderField,
    "order[1]": orderDir,
    "filter[budget_year][0]": budgetYear,
    "filter[round][0]": round,
    "filter[evaluate_salary_id][0]": evaluateSalaryID,
    "filter[user_id][0]": userID,
  };
  // if (status !== undefined && budgetYear >= NEW_BUDGET_YEAR_MIGRATE) {
  //   filters["filter[step_status][0]"] = status;
  // }
  if (checkPointApproved && approveCheckPointUser) {
    filters["filter[created_user_id][0]"] = checkPointApproved ? approveCheckPointUser?.approve_user_id : userID
  }
  if ((lastStepApproved && assessor1)) {
    filters["filter[created_user_id][0]"] = assessor1?.approve_user_id
  }
  return new URLSearchParams(filters);
};

function Form3PDF(props) {
  const {
    budgetYear,
    round,
    evaluateSalaryID,
    userID,
    userName,
    witnessUserID,
    witnessDate,
    witnessSignnum,
    witnessUser,
    confirmDate,
    updateApprove,
    task,
    approveId,
    version,
    userDepartment,
    showLeka = true,
    evaluateDataItem,
    approveCheckPointUser,
    checkPointApproved = null,
    lastStepApproved = null,
  } = props;

  let assessor1 = evaluateDataItem?.evaluateSalaryFlow.find(x => x?.assessor === 1)

  const evaluateSalaryApprove = evaluateDataItem?.evaluateSalaryApprove ?? [];
  const approveCheckpointData = approveCheckPointUser;
  const approveData = evaluateDataItem?.evaluateSalaryFlow?.find(
    x => x.approve_user_id === approveCheckpointData?.approve_user_id
  );

  const approveIdNew = approveData?.approve_user_id;

  const adjustApproveLevelArr = adjustApproveLevel(evaluateDataItem?.evaluateSalaryFlow, approveCheckpointData?.approve_user_id);

  const approveUserLv2 = adjustApproveLevelArr ? pickUserLevelEvaluateFlow(adjustApproveLevelArr, [3, 4, 2]) : null;
  const approveUserLv3Data = adjustApproveLevelArr ? pickUserLevelEvaluateFlow(adjustApproveLevelArr, [2]) : null;
  const approveUserLv3 = (approveUserLv3Data?.approve_user_id !== approveUserLv2?.approve_user_id) ? approveUserLv3Data : null;

  const [formFourData, setFormFourData] = useState([]);
  const [userData, setUserData] = useState(null);
  const [calculatedValues, setCalculatedValues] = useState(null);
  const [fullName, setFullName] = useState("");
  const [witnessFullName, setWitnessFullName] = useState("");
  const [ApproveFullNameLv1, setApproveFullNameLv1] = useState("");
  const [ApproveFullNameLv2, setApproveFullNameLv2] = useState("");
  const [ApproveFullNameLv3, setApproveFullNameLv3] = useState("");
  const [ApproveNameLv1, setApproveNameLv1] = useState("");
  const [ApproveNameLv2, setApproveNameLv2] = useState("");
  const [ApproveNameLv3, setApproveNameLv3] = useState("");
  const [witnessApproveFullNameLv1, setWitnessApproveFullNameLv1] = useState("");
  const [witnessApproveFullNameLv2, setWitnessApproveFullNameLv2] = useState("");
  const [witnessApproveFullNameLv3, setWitnessApproveFullNameLv3] = useState("");
  const [userInfo, setUserInfo] = useState([]);
  const [dataInfo, setDataInfo] = useState([]);
  const [evaluateData, setEvaluateData] = useState([]);
  const [masterdata, setMasterdata] = useState([]);
  const [calculatedValuesForm2, setCalculatedValuesForm2] = useState([]);
  const [evaluateDataBehavior, setEvaluateDataBehavior] = useState([]);
  const [evaluateApprove, setEvaluateApprove] = useState([]);
  const [modal, setModal] = useState(false);
  const [appUser, setAppUser] = useState(null);
  const [positionHighLevel, setPositionHighLevel] = useState(null);
  const [loading, setLoading] = useState(false);

  const toggle = () => setModal(!modal);

  const token = GetCookieToken("userToken");

  const fetchStepStatus = async evaluateSalaryId => {
    const params = new URLSearchParams({
      page: 1,
      size: 100,
      "order[0]": "evaluate_salary_approve_id",
      "order[1]": "DESC",
      "filter[evaluate_salary_id][0]": evaluateSalaryId,
    });
    const evaluateApprove = await FetchAxiosGet("/api/evaluateSalaryApprove/datatable", token, params);
    const filteredData = evaluateApprove.result.map(item => ({
      evaluate_status: item.evaluate_status,
      approve_user: item.approve_user,
      approve_user_id: item.approve_user_id,
    }));
    if (task === 1) {
      return 1;
    } else if (task === 2) {
    } else if (task === 3) {
      return 3;
    }
  };

  const [formTheeData_1, setFormTheeData_1] = useState({
    label: "องค์ประกอบที่ 1 : ผลสัมฤทธิ์ของงาน",
    score: "",
    percentage: EVALUATE_WEIGHT_NORMAL.first,
  });

  const [formTheeData_2, setFormTheeData_2] = useState({
    label: "องค์ประกอบที่ 2 : พฤติกรรมการปฏิบัติราชการ(สมรรถนะ)",
    score: "",
    percentage: EVALUATE_WEIGHT_NORMAL.second,
  });

  // น้ำหนักองค์ประกอบ: ปกติ 70/30 แต่ถ้า "ยังไม่ผ่านการทดลองงาน" (user_trial = 1) ใช้ 50/50
  useEffect(() => {
    const weight = getEvaluateWeight(dataInfo);
    setFormTheeData_1(prevData => ({ ...prevData, percentage: weight.first }));
    setFormTheeData_2(prevData => ({ ...prevData, percentage: weight.second }));
  }, [dataInfo?.user_trial]);

  const fetchEvaluateResult = async () => {
    const status = await fetchStepStatus(evaluateSalaryID);
    const params = buildEvaluateParams({
      orderField: "evaluate_salary_result_id",
      orderDir: "DESC",
      size: 10,
      status,
      budgetYear,
      round,
      evaluateSalaryID,
      userID,
      checkPointApproved, approveCheckPointUser, lastStepApproved, assessor1
    });
    const config = {
      headers: { Authorization: `Bearer ${token}` },
      params,
    };
    await axios
      .get(`${API_URL}/api/evaluateSalaryResult/datatable`, config)
      .then(response => {
        const result = response.data.result;
        let maxStep = -Infinity;
        for (const r of result) {
          if (r.step_active > maxStep) {
            maxStep = r.step_active;
          }
        }
        const newData = result.filter(r => r.step_active === maxStep);
        setEvaluateData(newData);
      })
      .catch(error => console.error("Error:", error));
  };

  const fetchEvaluateBehavior = async () => {
    const status = await fetchStepStatus(evaluateSalaryID);
    const params = buildEvaluateParams({
      orderField: "user_id",
      orderDir: "ASC",
      size: 10,
      status,
      budgetYear,
      round,
      evaluateSalaryID,
      userID, checkPointApproved, approveCheckPointUser, lastStepApproved, assessor1
    });
    const config = {
      headers: { Authorization: `Bearer ${token}` },
      params,
    };
    axios
      .get(`${API_URL}/api/evaluateSalaryBehavior/datatable`, config)
      .then(response => {
        setFormTwoData(prevFormTwoData =>
          prevFormTwoData.map(formItem => {
            const matchingEvaluateData = response.data.result.find(evalItem => evalItem.no === formItem.no);
            return {
              ...formItem,
              score: matchingEvaluateData ? matchingEvaluateData.score : "",
            };
          })
        );

        setEvaluateDataBehavior(prevState => {
          const newData = response.data.result.filter(i => i.score !== null);
          return [...prevState, ...newData];
        });
      })
      .catch(error => console.error("Error:", error));
  };

  const fetchEvaluateDevelopment = async () => {
    const status = await fetchStepStatus(evaluateSalaryID);
    const params = buildEvaluateParams({
      orderField: "user_id",
      orderDir: "ASC",
      size: 10,
      status,
      budgetYear,
      round,
      evaluateSalaryID,
      userID, checkPointApproved, approveCheckPointUser, lastStepApproved, assessor1
    });

    const config = {
      headers: { Authorization: `Bearer ${token}` },
      params,
    };
    axios
      .get(`${API_URL}/api/evaluateSalaryDevelopment/datatable`, config)
      .then(response => {
        setFormFourData(response.data.result);
      })
      .catch(error => console.error("Error:", error));
  };

  useEffect(() => {
    const letEffect = async () => {
      setLoading(true);
      await fetchEvaluateResult();
      await fetchEvaluateBehavior();
      await fetchEvaluateDevelopment();
      setTimeout(() => {
        setLoading(false);
      }, 2500);
    };
    letEffect();
  }, [budgetYear, round, evaluateSalaryID, userID, userName, witnessUserID, confirmDate, updateApprove]);

  const pdfRef = useRef();

  const [buttonLoading, setButtonLoading] = useState(false);
  const downloadPDF = async () => {
    setButtonLoading(true);
    const input = pdfRef.current;
    await html2canvas(input, { scale: 2 }).then(canvas => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("d", "mm", "a4", true);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      let imgHeight = (canvas.height * pdfWidth) / canvas.width;

      let heightLeft = imgHeight;
      let position = 0;
      let leftMargin = 10;
      let rightMargin = 10;

      pdf.addImage(imgData, "PNG", leftMargin, position, pdfWidth - leftMargin - rightMargin, imgHeight);
      heightLeft -= pdfHeight;

      while (heightLeft >= 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, "PNG", leftMargin, position, pdfWidth - leftMargin - rightMargin, imgHeight);
        heightLeft -= pdfHeight;
      }

      pdf.save("แบบสรุปการประเมินผลการปฏิบัติราชการ.pdf");
      setTimeout(() => {
        setButtonLoading(false);
      }, 1000);
    });
  };

  useEffect(() => {
    const url = `${API_URL}/api/users/${userID}`;
    const config = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: `Bearer ${token}`,
      },
    };
    axios
      .get(url, config)
      .then(response => {
        setDataInfo(response.data.result);
      })
      .catch(error => {
        console.error(error);
      });
  }, []);

  // ใบประเมินปี 2569 รอบ 1 และปีก่อนหน้า ใช้สมรรถนะชุดเก่า
  const useOldBehaviorRows = shouldUseOldBehaviorRows(budgetYear, round);
  const [formTwoData, setFormTwoData] = useState(() => createBehaviorRows(false, null, useOldBehaviorRows));

  useEffect(() => {
    const calculatedValues = evaluateData.map((group, index) => (group.weight * group.score) / 100);
    const sum = calculatedValues.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
    setCalculatedValues(sum);
    setFormTheeData_1(prevData => ({
      ...prevData,
      score: (sum * (100 / 5)).toFixed(4),
    }));
  }, [evaluateData]);

  useEffect(() => {
    const calculatedValues = formTwoData.map(
      (group, index) => (group.score * group.percentage) / 100
    );
    const sum = calculatedValues.reduce(
      (accumulator, currentValue) => accumulator + currentValue.toFixed(4) * 1,
      0
    );
    
    setCalculatedValues(sum.toFixed(4));
    setFormTheeData_2(prevData => ({
      ...prevData,
      score: (sum * (100 / 5)).toFixed(4),
    }));
  }, [formTwoData]);

  const fetchMasterData = async () => {
    try {
      const response = await axios.get(`${API_URL}/api/users/config/all`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setMasterdata(response.data.result);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const fetchUserData = async () => {
    if (updateApprove?.approve_user_id !== undefined) {
      const url = `${API_URL}/api/users/position/datatable`;
      const params = new URLSearchParams({
        page: 1,
        size: 1000,
        "order[0]": "position_id",
        "order[1]": "ASC",
        "filter[user_id][0]": updateApprove?.approve_user_id,
      });
      const config = {
        headers: { Authorization: `Bearer ${token}` },
        params,
      };
      await axios
        .get(url, config)
        .then(response => {
          setUserData(response.data.result);
        })
        .catch(error => console.error("Error:", error));
    }
  };

  useEffect(() => {
    const url = `${API_URL}/api/users/${userID}`;
    const config = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: `Bearer ${token}`,
      },
    };
    axios
      .get(url, config)
      .then(response => {
        setUserInfo(response.data.result);
      })
      .catch(error => {
        console.error(error);
      });
    fetchMasterData();
  }, []);

  useEffect(() => {
    fetchUserData();
  }, [updateApprove]);

  let filteredMasterDataPostion;

  const typeEMP = masterdata.user_type_emp?.find(i => i.type_emp_id === parseInt(userInfo.user_category_id, 10));

  const filteredMasterData = masterdata.user_type_emp?.filter(item => item.type_emp_id === userInfo.user_category_id);
  if (typeEMP && typeEMP.user_level_emp !== undefined) {
    filteredMasterDataPostion = typeEMP.user_level_emp?.filter(item => item.level_emp_id === userInfo.user_level_id);
  }

  const result =
    (formTheeData_2.score * formTheeData_2.percentage) / 100 + (formTheeData_1.score * formTheeData_1.percentage) / 100;

  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({ width: window.innerWidth, height: window.innerHeight });
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const fetchFullName = async (userID, setName = null, setFullName, wit = false) => {
    const url = `/api/users/${userID}`;
    if (userID) {
      await FetchAxiosGet(url, token)
        .then(ress => {
          const tietleName = ress.result?.user_title_name;
          const name = ress.result?.user_name;
          const fullName = `${tietleName}${name}`;
          setFullName(fullName);
          setName && setName(name);
        })
        .catch(err => {
          console.error(err);
          return null;
        });
    }
  };

  const fetchWitessApporve = async () => {
    const params = new URLSearchParams({
      page: 1,
      size: 100,
      "order[0]": "evaluate_salary_approve_id",
      "order[1]": "ASC",
      "filter[evaluate_salary_id][0]": evaluateSalaryID,
    });
    const evaluateApprove = await FetchAxiosGet("/api/evaluateSalaryApprove/datatable", token, params);
    const index = evaluateApprove?.result.findIndex(x => x.approve_user_id == approveIdNew && x.version == version);
    setEvaluateApprove(evaluateApprove?.result);
    approveIdNew && fetchFullName(approveIdNew, null, setApproveFullNameLv1);
    approveUserLv2?.approve_user_id && fetchFullName(approveUserLv2?.approve_user_id, setApproveNameLv2, setApproveFullNameLv2);
    approveUserLv3?.approve_user_id && fetchFullName(approveUserLv3?.approve_user_id, setApproveNameLv3, setApproveFullNameLv3);
    fetchFullName(
      evaluateApprove?.result.find(x => x.approve_user_id == approveIdNew && x.version == version)?.approve_user_id,
      null,
      setWitnessApproveFullNameLv1,
      true
    );
    fetchFullName(evaluateApprove?.result[index + 1]?.approve_user_id, null, setWitnessApproveFullNameLv2, true);
    fetchFullName(evaluateApprove?.result[index + 2]?.approve_user_id, null, setWitnessApproveFullNameLv3, true);
  };

  useEffect(() => {
    fetchFullName(userID, null, setFullName);
    fetchWitessApporve();
    if (witnessUserID) {
      fetchFullName(witnessUserID, null, setWitnessFullName, true);
    }
  }, []);

  return (
    <Fragment>
      <Button className="text-nowrap" color="success" onClick={() => toggle()}>
        แบบฟอร์มที่ 3
      </Button>
      <Modal size="lg" centered isOpen={modal} toggle={toggle}>
        <ModalHeader>
          <div className="position-absolute top-0 end-0">
            <i
              className="fa-sharp fa-solid fa-circle-xmark pt-2 pe-3 h4"
              style={{ cursor: "pointer" }}
              onClick={toggle}
            ></i>
          </div>
        </ModalHeader>
        <ModalBody className="px-4" style={{ overflowX: "scroll" }}>
          {loading ? (
            <div>
              <Lottie
                options={{
                  loop: true,
                  autoplay: true,
                  animationData: loadingLeaveSumary.default,
                  rendererSettings: { preserveAspectRatio: "xMidYMid slice" },
                }}
                width={200}
                height={200}
              />
            </div>
          ) : (
            <Fragment>
              <div ref={pdfRef} style={{ minWidth: "726.4px" }}>
                <Container fluid className="ps-4 pe-4" style={{ fontFamily: "Sarabun,serif" }}>
                  <Row>
                    <Col lg={12} className="text-end mt-2">
                      <i>แบบฟอร์มหมายเลข 3</i>
                    </Col>
                  </Row>
                  <br />
                  <br />
                  <Row>
                    <Col lg={12} className="text-center fw-light">
                      <h4>
                        <b>แบบสรุปการประเมินผลการปฏิบัติราชการ</b>
                      </h4>
                    </Col>
                  </Row>
                  <br />
                  <Row className="mt-2">
                    <b className="text-decoration-underline" style={{ fontSize: "14px" }}>
                      ส่วนที่ 1: ข้อมูลของผู้รับการประเมิน
                    </b>
                  </Row>
                  <Fragment>
                    <Row className="mt-2">
                      <Col xs={2} md={2} lg={2}>
                        <span>รอบการประเมิน</span>
                      </Col>
                      <Col xs={10} md={10} lg={10}>
                        <CheckMark
                          checked={round === 1}
                          checkedClassName="fa-solid fa-check py-1 p-1 fa-lg"
                          emptyPadding="9.5px"
                          emptyMarginRight="4.5px"
                        />
                        <span className="pe-3"> รอบที่ 1</span>
                        <span className="pe-3">1 ตุลาคม</span>
                        {round === 1 ? (
                          <span className="pe-3">
                            <b>{Number(budgetYear) - 1}</b>
                          </span>
                        ) : (
                          <span style={{ paddingLeft: "49.5px" }}></span>
                        )}
                        <span className="pe-3">ถึง 31 มีนาคม</span>
                        {round === 1 ? (
                          <span>
                            {" "}
                            <b>{Number(budgetYear)}</b>{" "}
                          </span>
                        ) : (
                          <span></span>
                        )}
                      </Col>
                    </Row>
                    <Row className="mt-2">
                      <Col xs={2} md={2} lg={2}></Col>
                      <Col xs={10} md={10} lg={10}>
                        <CheckMark
                          checked={round === 2}
                          checkedClassName="fa-solid fa-check py-1 p-1 fa-lg"
                          emptyPadding="9.5px"
                          emptyMarginRight="4.5px"
                        />
                        <span className="pe-3" style={{ paddingLeft: "2.5px" }}>
                          รอบที่ 2
                        </span>
                        <span className="pe-3">1 เมษายน</span>
                        {round === 2 ? (
                          <span className="pe-3">
                            {" "}
                            <b>{budgetYear}</b>{" "}
                          </span>
                        ) : (
                          <span style={{ paddingLeft: "39.5px" }}></span>
                        )}
                        <span className="pe-3">ถึง 30 กันยายน</span>
                        {round === 2 ? (
                          <span>
                            {" "}
                            <b>{Number(budgetYear)}</b>{" "}
                          </span>
                        ) : (
                          <span></span>
                        )}
                      </Col>
                    </Row>
                  </Fragment>

                  <Row className="mt-2">
                    <Col xs={12} md={12} lg={12}>
                      <span className="pe-3">ชื่อผู้รับการประเมิน</span>
                      <span>
                        <b>{fullName}</b>
                      </span>
                    </Col>
                  </Row>
                  <Row className="mt-2">
                    <Col xs={6} md={6} lg={6}>
                      <span className="pe-3">ตำแหน่ง</span>{" "}
                      <span>
                        <b>{evaluateDataItem?.evaluate_user_position_name ?? "-"}</b>
                      </span>
                    </Col>
                    <Col xs={6} md={6} lg={6}>
                      <span className="pe-3">ประเภทตำแหน่ง</span>{" "}
                      <span>
                        <b>{filteredMasterData?.map(i => i.type_emp_name).toString()}</b>
                      </span>
                    </Col>
                  </Row>
                  <Row className="mt-2">
                    <Col xs={6} md={6} lg={6}>
                      <span className="pe-3">ระดับตำแหน่ง</span>{" "}
                      <span>
                        <b>{filteredMasterDataPostion?.map(i => i.level_emp_name).toString()}</b>
                      </span>
                    </Col>
                    <Col xs={6} md={6} lg={6}>
                      <span className="pe-3">สังกัด</span>
                      <span>
                        <b>{userDepartment}</b>
                      </span>
                    </Col>
                  </Row>
                  <Row className="mt-2">
                    <Col xs={12} md={12} lg={12}>
                      <span className="pe-3">ชื่อผู้ประเมิน</span>
                      <span>
                        <b>{approveData?.approve_user ?? ""}</b>
                      </span>
                    </Col>
                  </Row>
                  <Row className="mt-2">
                    <Col xs={12} md={12} lg={12}>
                      <span className="pe-3">ตำแหน่ง</span>{" "}
                      <span>
                        <b>{approveData?.approve_user_position_name ?? "-"}</b>
                      </span>
                    </Col>
                  </Row>
                  <br />
                  <Row className="mt-2 mb-1">
                    <b className="text-decoration-underline" style={{ fontSize: "14px" }}>
                      ส่วนที่ 2: การสรุปผลการประเมิน
                    </b>
                  </Row>
                  <table className="border border-1 border-black">
                    <thead className="table-light" style={{ whiteSpace: "nowrap" }}>
                      <tr>
                        <th className="text-center border border-1 border-black">องค์ประกอบการประเมิน</th>
                        <th className="text-center border border-1 border-black">
                          คะแนน
                          <br />
                          น้ำหนัก(ก)
                        </th>
                        <th className="text-center border border-1 border-black">
                          สัดส่วนคะแนน
                          <br />
                          น้ำหนัก(ข)
                        </th>
                        <th className="text-center border border-1 border-black">
                          รวมคะแนน
                          <br />
                          (ก) x (ข)
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {[formTheeData_1, formTheeData_2].map((item, idx) => (
                        <tr key={idx}>
                          <td className="border border-1 border-black ps-2" style={{ width: "600px" }}>
                            {item.label}
                          </td>
                          <td className="text-center border border-1 border-black ps-2" style={{ width: "150px" }}>
                            {Number(item.score).toFixed(4)}
                          </td>
                          <td className="text-center border border-1 border-black ps-2" style={{ width: "150px" }}>
                            {item.percentage}%
                          </td>
                          <td className="text-center border border-1 border-black ps-2" style={{ width: "150px" }}>
                            {item.score !== "" ? ((item.score * item.percentage) / 100).toFixed(4) : ""}
                          </td>
                        </tr>
                      ))}
                      <tr>
                        <td className="border border-1 border-black pe-2 text-end" style={{ width: "600px" }}>
                          รวม 100%
                        </td>
                        <td className="text-center border border-1 border-black ps-2" style={{ width: "150px" }}></td>
                        <td className="text-center border border-1 border-black ps-2" style={{ width: "150px" }}></td>
                        <td className="text-center border border-1 border-black ps-2" style={{ width: "150px" }}>
                          {formTheeData_2.score !== ""
                            ? (
                                Number((formTheeData_2.score * formTheeData_2.percentage) / 100) +
                                Number((formTheeData_1.score * formTheeData_1.percentage) / 100)
                              ).toFixed(4)
                            : ""}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <Row>
                    <Row>
                      <b>ระดับผลการประเมิน</b>
                    </Row>
                    <Row className="text-center mt-1 mx-auto ">
                      {SCORE_LEVELS.map(level => (
                        <Col key={level.label}>
                          <Row>
                            <Col>
                              <CheckMark checked={level.test(result)} />
                              <span>{level.label}</span>
                            </Col>
                          </Row>
                          <Row>
                            <Col>
                              <span style={{ paddingLeft: "33px" }}>
                                <i>{level.range}</i>
                              </span>
                            </Col>
                          </Row>
                        </Col>
                      ))}
                    </Row>
                  </Row>
                  <br />
                  <br />
                  <Row className="mb-1">
                    <b className="text-decoration-underline" style={{ fontSize: "14px" }}>
                      ส่วนที่ 3: การรับทราบผลการประเมินผู้ประเมิน
                    </b>
                  </Row>
                  <Row className="border border-1 border-black">
                    <Row className="mt-1">
                      <b>ผู้ประเมิน :</b>
                    </Row>

                    <Fragment>
                      <Row className="mt-1 ms-2">
                        <Col>
                          <CheckMark
                            checked={confirmDate !== null && witnessUserID === null}
                            emptyPadding="8.7px"
                            emptyMarginRight="4.5px"
                          />
                          <span>ได้แจ้งผลการประเมินและผู้รับการประเมินได้ลงนามรับทราบ</span>
                        </Col>
                      </Row>
                      <Row className="mt-1 ms-2">
                        <Col>
                          <CheckMark
                            checked={witnessUserID !== null && confirmDate !== null}
                            emptyPadding="8.7px"
                            emptyMarginRight="4.5px"
                          />
                          <span>
                            ได้แจ้งผลการประเมินเมื่อวันที่{" "}
                            <b>{evaluateDataItem?.date_end_confirm ? convertToThaiDate(evaluateDataItem?.date_end_confirm) : ""}</b>
                          </span>
                        </Col>
                        <Col>
                          <span>
                            <span>ลงชื่อ : </span>
                            <DottedField width="250px">
                              {approveCheckpointData && `${approveCheckpointData?.approve_user}`}
                            </DottedField>
                          </span>
                        </Col>
                      </Row>
                    </Fragment>

                    <Row className="ms-2">
                      <Col>
                        <span style={{ paddingLeft: "32px" }}>แต่ผู้รับการประเมินไม่ลงนามรับทราบ</span>
                      </Col>
                      <Col className="text-center">
                        <span>
                          <DottedField width="250px">{ApproveFullNameLv1 ? `(${ApproveFullNameLv1})` : ""}</DottedField>
                        </span>
                      </Col>
                    </Row>
                    <Row className="ms-2">
                      <Col></Col>
                      <Col>
                        <span className="">ตำแหน่ง : </span>
                        <DottedField width="235px">{approveData?.approve_user_position_name}</DottedField>
                      </Col>
                    </Row>
                    <Row className="ms-2 mt-2">
                      <Col>
                        <span style={{ paddingLeft: "32px" }}>
                          <span>โดยมี</span>
                          <DottedField width="170px">
                            {witnessUserID !== null && confirmDate !== null ? witnessFullName : ""}
                          </DottedField>
                          <span>เป็นพยาน</span>
                        </span>
                      </Col>
                      <Col>
                        <span className="text-end">วันที่ : </span>
                        <DottedField width="255px">
                          {convertToThaiDate(checkMaxDate(approveCheckpointData?.approve_date, evaluateDataItem?.date_end_confirm))}
                        </DottedField>
                      </Col>
                    </Row>
                    <Row className="ms-2 mt-2">
                      <Col>
                        <span style={{ paddingLeft: "32px" }}>
                          <span>ลงชื่อ : </span>
                          <DottedField width="158px">
                            {witnessUserID !== null && confirmDate !== null ? witnessUser : ""}
                          </DottedField>
                          <span>พยาน</span>
                        </span>
                      </Col>
                    </Row>
                    <Row className="ms-2 mt-2">
                      <Col>
                        <span style={{ paddingLeft: "32px" }}>
                          <span></span>
                          <DottedField width="215px" className="ms-4">
                            {witnessUserID !== null && confirmDate !== null ? `(${witnessFullName})` : ""}
                          </DottedField>
                        </span>
                      </Col>
                    </Row>
                    <Row className="ms-2 mt-2">
                      <Col>
                        <span style={{ paddingLeft: "32px" }} className="">
                          <span>ตำแหน่ง : </span>
                          <DottedField width="auto" extraStyle={{ minWidth: "187px" }}>
                            {witnessUserID !== null && confirmDate !== null ? evaluateDataItem?.witness_user_position_name : ""}
                          </DottedField>
                        </span>
                      </Col>
                    </Row>
                    <Row className="ms-2 mt-2 mb-1">
                      <Col>
                        <span style={{ paddingLeft: "32px" }}>
                          <span>วันที่ : </span>
                          <DottedField width="208px">
                            {witnessUserID !== null && confirmDate !== null && evaluateDataItem?.witness_date
                              ? convertToThaiDate(evaluateDataItem?.witness_date)
                              : ""}
                          </DottedField>
                        </span>
                      </Col>
                    </Row>
                  </Row>
                  <Row className="border border-1 border-black">
                    <Row className="mt-1">
                      <b>ผู้รับการประเมิน :</b>
                    </Row>
                    <Row className="mt-1 ms-2">
                      <Col>
                        <CheckMark checked={confirmDate !== null || witnessUserID !== null} emptyPadding="8.7px" emptyMarginRight="4.5px" />
                        <span>ได้รับทราบผลการประเมินและแผนพัฒนาการปฏิบัติราชการรายบุคคลแล้ว</span>
                      </Col>
                    </Row>
                    <Row className="mt-1 ms-2">
                      <Col></Col>
                      <Col>
                        <span>ลงชื่อ : </span>
                        <DottedField width="250px">
                          {(confirmDate !== null || witnessUserID !== null) && userName}
                        </DottedField>
                      </Col>
                    </Row>
                    <Row className="ms-2">
                      <Col></Col>
                      <Col className="text-center">
                        <DottedField width="250px">{fullName ? `(${fullName})` : ""}</DottedField>
                      </Col>
                    </Row>
                    <Row className="ms-2">
                      <Col></Col>
                      <Col>
                        <span className="">ตำแหน่ง : </span>
                        <DottedField width="235px">{dataInfo.user_position_name}</DottedField>
                      </Col>
                    </Row>
                    <Row className="ms-2 mt-2 mb-2">
                      <Col></Col>
                      <Col>
                        <span className="text-end">วันที่ :</span>
                        <DottedField width="260px">{convertToThaiDate(confirmDate)}</DottedField>
                      </Col>
                    </Row>
                  </Row>

                  <Row className="mt-5 mb-1">
                    <b className="text-decoration-underline" style={{ fontSize: "14px" }}>
                      ส่วนที่ 4: ความเห็นของผู้บังคับบัญชาเหนือขึ้นไป
                    </b>
                  </Row>
                  <SupervisorApprovalBlock
                    title="ผู้บังคับบัญชาเหนือขึ้นไป:"
                    approveUserLv={lastStepApproved ? approveUserLv2 : null}
                    approveNameLv={lastStepApproved ? ApproveNameLv2 : null}
                    approveFullNameLv={lastStepApproved ? ApproveFullNameLv2 : null}
                    evaluateSalaryApprove={lastStepApproved ? evaluateSalaryApprove : null}
                    dateSourceUserId={lastStepApproved ? approveUserLv2?.approve_user_id : null}
                  />
                  <SupervisorApprovalBlock
                    title="ผู้บังคับบัญชาเหนือขึ้นไปอีกชั้นหนึ่ง (ถ้ามี):"
                    approveUserLv={lastStepApproved ? approveUserLv3 : null}
                    approveNameLv={lastStepApproved ? ApproveNameLv3 : null}
                    approveFullNameLv={lastStepApproved ? ApproveFullNameLv3 : null}
                    evaluateSalaryApprove={lastStepApproved ? evaluateSalaryApprove : null}
                    dateSourceUserId={lastStepApproved ? approveUserLv3?.approve_user_id : null}
                  />
                  <br />

                  <Row className="mt-2 mb-1">
                    <b className="text-decoration-underline" style={{ fontSize: "14px" }}>
                      {" "}
                      ส่วนที่ 5: แผนพัฒนาการปฏิบัติราชการรายบุคคล
                    </b>
                  </Row>
                  <table style={{ marginBottom: "40px" }} className="border border-1 border-black">
                    <thead className="table-light" style={{ whiteSpace: "nowrap" }}>
                      <tr>
                        <th className="text-center border border-1 border-black">
                          ความรู้/ ทักษะ/ สมรรถนะ
                          <br />
                          ที่ต้องได้รับการพัฒนา
                        </th>
                        <th className="text-center border border-1 border-black">วิธีการพัฒนา</th>
                        <th className="text-center border border-1 border-black">ช่วงเวลาที่ต้องการการพัฒนา</th>
                      </tr>
                    </thead>
                    <tbody>
                      {formFourData.length !== 0 && formFourData !== null
                        ? formFourData
                            .slice()
                            .sort((a, b) => a.no - b.no)
                            .map((item, index) =>
                              item.development_type_id !== null ? (
                                <tr key={index}>
                                  <td className="border border-1 border-black ps-2" style={{ width: "270px" }}>
                                    {DEVELOPMENT_TYPE_TH.find(x => x.value === item.development_type_id)?.label ?? ""}
                                  </td>
                                  <td style={{ width: "270px" }} className="ps-2 border border-1 border-black">
                                    {item.development}
                                  </td>
                                  <td style={{ width: "100px" }} className="ps-2 border border-1 border-black"></td>
                                </tr>
                              ) : (
                                <tr key={index}>
                                  <td className="ps-2 border border-1 border-black" style={{ width: "270px", height: "30px" }}></td>
                                  <td className="ps-2 border border-1 border-black" style={{ width: "270px" }}></td>
                                  <td className="ps-2 border border-1 border-black" style={{ width: "100px" }}></td>
                                </tr>
                              )
                            )
                        : ""}
                    </tbody>
                  </table>
                  <div className="text-center">
                    <div
                      style={{
                        borderBottomStyle: "dashed",
                        borderWidth: "2px",
                        width: "90%",
                        display: "inline-block",
                      }}
                    ></div>
                  </div>
                  <Row className="mt-2 mb-2">
                    <h4 className="text-decoration-underline">คำชี้แจง</h4>
                    <div>แบบสรุปการประเมินผลการปฏิบัติราชการนี้มีด้วยกัน 2 หน้า ประกอบด้วย</div>
                    <div>
                      ส่วนที่ 1:
                      <span className="px-2 text-decoration-underline">ข้อมูลของผู้รับการประเมิน</span>
                      เพื่อระบุรายละเอียดต่าง ๆ ที่เกี่ยวข้องกับตัวผู้รับการประเมิน
                    </div>
                    <div>
                      ส่วนที่ 2:
                      <span className="px-2 text-decoration-underline">สรุปผลการประเมิน</span>
                      ใช้เพื่อกรอกค่าคะแนนการประเมินในองค์ประกอบด้านผลสัมฤทธิ์ของงาน องค์ประกอบด้านพฤติกรรม
                      การปฏิบัติราชการ และน้ำหนักของทั้งสององค์ประกอบ ในแบบสรุปส่วนที่ 2 นี้ ยังใช้สำหรับคำนวณคะแนนผลการปฏิบัติราชการรวมด้วย
                    </div>
                    <div className="ms-4">
                      - สำหรับคะแนนองค์ประกอบด้านผลสัมฤทธิ์ของงาน ให้นำมาจากแบบประเมินผลสัมฤทธิ์ของงาน โดยให้แนบท้ายแบบสรุปฉบับนี้
                    </div>
                    <div className="ms-4">
                      - สำหรับคะแนนองค์ประกอบด้านพฤติกรรมการปฏิบัติราชการ ให้นำมาจากแบบประเมินสมรรถนะ โดยให้แนบท้ายแบบสรุปฉบับนี้
                    </div>
                    <div>
                      ส่วนที่ 3:
                      <span className="px-2 text-decoration-underline">การรับทราบผลการประเมิน</span>
                      ผู้รับการประเมินลงนามรับทราบผลการประเมิน
                    </div>
                    <div>
                      ส่วนที่ 4:
                      <span className="px-2 text-decoration-underline">ความเห็นของผู้บังคับบัญชาเหนือขึ้นไป</span>
                      ผู้บังคับบัญชาเหนือขึ้นไปกลั่นกรองผลการประเมิน แผนพัฒนาผลการปฏิบัติราชการ และให้ความเห็น
                    </div>
                    <div>
                      ส่วนที่ 5:
                      <span className="px-2 text-decoration-underline">แผนพัฒนาการปฏิบัติราชการรายบุคคล</span>
                      ผู้ประเมินและผู้รับการประเมินร่วมกันจัดทำแผนพัฒนาผลการปฏิบัติราชการ คำว่า "ผู้บังคับบัญชาเหนือขึ้นไป"
                      สำหรับผู้ประเมินตามข้อ 2(9) หมายถึง หัวหน้าส่วนราชการประจำจังหวัดผู้บังคับบัญชาของผู้รับการประเมิน
                    </div>
                  </Row>
                </Container>
              </div>
              <Col xs={8} md={6} lg={4} xl={12}>
                <div
                  className={`
                  ${
                    windowSize.width < 576 || (windowSize.width >= 768 && windowSize.width < 992) || (windowSize.width >= 992 && windowSize.width < 1200)
                      ? "text-start ms-4"
                      : "text-end me-4"
                  }
                `}
                >
                  <Button disabled={buttonLoading} style={{ whiteSpace: "nowrap" }} className="mt-2 " color="success" onClick={downloadPDF}>
                    {buttonLoading === true ? (
                      <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
                    ) : (
                      <i className="fa-solid fa-print pe-2"></i>
                    )}
                    ดาวน์โหลดแบบฟอร์มที่ 3
                  </Button>
                </div>
              </Col>
            </Fragment>
          )}
        </ModalBody>
      </Modal>
    </Fragment>
  );
}

export default Form3PDF;